export default __webpack_public_path__ + "static/emily-3746d27a89f757e5890dad4aadaeb319.png";